import React from 'react'

const Loader = () => {
    return (
        <div className='loader-wrap'>
            <span className="loader"></span>
        </div>
    )
}

export default Loader